import React from "react";
import { Box, TextField, Typography } from "@mui/material";

export default function NotesEntry({ notes, onChange }) {
    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Additional Notes
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Add any additional notes, observations, or comments about this
                RF test report. This information will be included in the final
                report.
            </Typography>
            <TextField
                fullWidth
                multiline
                rows={12}
                value={notes}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Enter any additional notes here..."
                sx={{
                    "& .MuiOutlinedInput-root": {
                        fontFamily: "monospace",
                    },
                }}
            />
        </Box>
    );
}
